import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import Time from "react-time-format";
import "./rent.css";

const DetailOfRent = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            IT_phone,
            IT_name,
            IT_code,
            IT_no_invoice,
            IT_joripara,
            IT_date,
          } = value;
          return (
            <>
              <form
                className="border border-black "
                style={{ borderTop: "1px solid black", backgroundColor: "white" }}
              >
                <div className="">
                  <div className="row text-dark font-weight-bold f4 mt-2 border border-black">
                    <div className="col-3 text-right form-inline mt-2">
                      <p>
                        <Time
                          value={IT_date}
                          format="YYYY-MM-DD"
                          style={{ color: "black" }}
                        />
                      </p>
                    </div>
                    <div className="col-3 text-right form-inline">
                      <div className="form-group">
                        <h5 className=" f4 mt-2" style={{ color: "black" }}>
                          {IT_phone}
                        </h5>
                        <label
                          className="font-weight-bold f4 ml3"
                          style={{ color: "black" }}
                        >
                          :تەلەفۆن
                        </label>
                      </div>
                    </div>

                    <div className="col-3 text-right  form-inline ">
                      <div className="form-group">
                        <h5 className=" ml5 f4 mt-2" style={{ color: "black" }}>
                          {IT_name}
                        </h5>
                        <label
                          className="font-weight-bold f4 ml1"
                          style={{ color: "black" }}
                        >
                          :بەڕێز
                        </label>
                      </div>
                    </div>

                    <div className="col-3 text-right form-inline">
                      <div className="form-group ">
                        <h5 className=" ml5 f4 mt-2" style={{ color: "black" }}>
                          {IT_code}
                        </h5>
                        <label
                          className="font-weight-bold f4 ml3"
                          style={{ color: "black" }}
                        >
                          :بەڕێز ژمارە
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* row 2 */}
                <hr style={{ border: "0.3px solid black" }} />
                <div className="row text-dark font-weight-bold f4  mr-4 border border-black">
                  <div className="col-3 text-right form-inline mb-2">
                    <p>
                      <Time
                        value={IT_date}
                        format="hh:mm:ss"
                        style={{ color: "black" }}
                      />
                    </p>
                  </div>
                  <div className="col-3 text-right form-inline ">
                    <div className="form-group ml3">
                      <h5 className=" f4" style={{ color: "black" }}>
                        {"ڕەهیل جاسم"}
                      </h5>
                      <label
                        className="font-weight-bold mb-2 f4 ml3"
                        style={{ color: "black" }}
                      >
                        : ناوی وەرگر
                      </label>
                    </div>
                  </div>

                  <div className="col-3 text-right  form-inline">
                    <div className="form-group ">
                      <h5 className=" ml5 f4" style={{ color: "black" }}>
                        {IT_joripara}-مفرد
                      </h5>
                      <label
                        className="font-weight-bold mb-2 f4 ml1 "
                        style={{ color: "black" }}
                      >
                        : جۆری دراو
                      </label>
                    </div>
                  </div>
                  <div className="col-3 text-right form-inline">
                    <div className="form-group ">
                      <h5 className=" ml5 f4" style={{ color: "black" }}>
                        {IT_no_invoice}
                      </h5>
                      <label
                        className="font-weight-bold mb-2 f4 ml3"
                        style={{ color: "black" }}
                      >
                        : ژمارەی پسوولە
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default DetailOfRent;
